/*eslint-disable */

import footer from '@/components/footer/index.vue';
import header from '@/components/header/index.vue';

export default {
  name: 'app',
  components: {
    'app-header':header,
    'app-footer':footer,
  },
  props: [],
}
